import { render, staticRenderFns } from "./limit_speed.vue?vue&type=template&id=a9f3f346&scoped=true&"
import script from "./limit_speed.vue?vue&type=script&lang=js&"
export * from "./limit_speed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f3f346",
  null
  
)

export default component.exports